import { useQuery } from '@tanstack/react-query'

import type { GetFeaturedFlightDatesResponse } from '../../types/featured-flight.js'

import { apiClient } from '../../lib/client.js'
import { featuredFlightKeys } from './keys.js'

/** Jours avec vol direct de `from` vers `to` ; inactif tant qu'un des deux manque. */
export const useGetFeaturedFlightDatesQuery = (from?: string, to?: string) => {
  return useQuery({
    enabled: Boolean(from && to),
    queryFn: async () => {
      const response = await apiClient.client.get<GetFeaturedFlightDatesResponse>(
        '/featured-flight/dates',
        { params: { from, to } }
      )
      return response.data
    },
    queryKey: featuredFlightKeys.dates(from ?? '', to ?? ''),
    // Recalculées une fois par nuit : inutile de les redemander à chaque ouverture.
    staleTime: 60 * 60 * 1000,
  })
}
